import { Application, Container, Ticker } from "pixi.js";
import { fish, FishDefinition } from "./fish";
import { player } from "./player";
import { bubble1 } from "./spritesheets/bubble1";
import { Soundboard } from "./soundboard";
import { viewport } from "./viewport";
import { background } from "./background";
import { AIFish, SchoolAttributes } from "./robofish";

export const pixiApplication = async (
  fishList: (FishDefinition & { school: SchoolAttributes })[],
  soundboard: Soundboard,
) => {
  const app = new Application();
  await app.init({ background: "#00d4ff", resizeTo: window });
  app.canvas.style.position = "absolute";
  app.canvas.style.display = "block";

  soundboard.underwater.play();
  soundboard.underwater.loop = true;

  const stage: Container = new Container();
  stage.addChild(await AIFish(200, app, fishList));

  let bubbleExists = false;

  app.stage.addChild(background(app, stage));

  const bubble = async (x: number, y: number) => {
    if (bubbleExists) {
      return;
    }
    bubbleExists = true;
    soundboard.bubbleSound.play();
    const bubbleSprite = await bubble1();
    bubbleSprite.x = x;
    bubbleSprite.y = y;
    const bubbleTicker = new Ticker();
    bubbleTicker.add((t: Ticker) => {
      bubbleSprite.y -= t.deltaMS / 10;
      bubbleSprite.x += (Math.round(1.5 - Math.random() * 3) * t.deltaMS) / 10;
      if (Math.random() * 100 < t.deltaMS * 1) {
        if (bubbleSprite.currentFrame === bubbleSprite.totalFrames - 1) {
          bubbleTicker.destroy();
          bubbleSprite.destroy();
          bubbleExists = false;
        } else {
          bubbleSprite.gotoAndStop(bubbleSprite.currentFrame + 1);
        }
      }
    });
    stage.addChild(bubbleSprite);
    bubbleTicker.start();
  };

  const f = await fish(app, fishList[4]);
  f.sprite.x = 400;
  f.sprite.y = 400;
  player(app, f, bubble);

  viewport(stage, f.sprite, app);

  stage.addChild(f.sprite);

  app.stage.addChild(stage);

  window.addEventListener("gamepadconnected", (e) => {
    e.gamepad.vibrationActuator.playEffect("dual-rumble", {
      startDelay: 0,
      duration: 250,
      weakMagnitude: 1,
      strongMagnitude: 1,
    });
    setTimeout(() => {
      e.gamepad.vibrationActuator.playEffect("dual-rumble", {
        startDelay: 0,
        duration: 250,
        weakMagnitude: 1,
        strongMagnitude: 1,
      });
    }, 400);
  });

  app.renderer.render(app.stage);
  function gameLoop(): void {
    app.renderer.render(app.stage);
    requestAnimationFrame(gameLoop);
  }
  gameLoop();

  return app.canvas;
};
